import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, Compass, Users, MessageCircle, User } from "lucide-react";
import { useUnread } from "../lib/community";
import { useAuth } from "../lib/auth";
import { haptic } from "../lib/haptics";

// Routes that are immersive or belong to a couple's own site — no app chrome there.
export const HIDE_TABBAR = /^\/(dashboard|login|signup|auth|onboarding|choose-plan|live\/|messages\/|party\/|party-screen\/|print\/|setup-fee|session\/|play\/|reception\/|site\/|podcast\/live\/|therapy\/session\/|agreements\/sign\/|admin|call-center|planner|video-note\/|pay\/|premiere\/|shared\/|guest(\/|$)|reception-live\/|invite\/|s\/|thanks\/|social$|careers\/me|careers\/interview\/|seo-center|record\/|doc\/|verify\/)/;

function Tab({ to, label, icon: Icon, end, badge = 0 }) {
  return (
    <NavLink to={to} end={end} onClick={() => haptic()} data-testid={`tabbar-${label.toLowerCase()}`}
      className="relative flex-1 flex flex-col items-center justify-center gap-0.5 py-1.5 text-[10px] uppercase tracking-[0.14em]">
      {({ isActive }) => (
        <>
          {isActive && <motion.span layoutId="tabbar-pill" className="absolute inset-x-2 inset-y-0.5 rounded-2xl bg-[#C8A96B]/12" transition={{ type: "spring", stiffness: 500, damping: 38 }} />}
          <span className="relative">
            <Icon className={`w-5 h-5 transition-colors ${isActive ? "text-[var(--gold)]" : "text-[var(--muted)]"}`} strokeWidth={1.7} />
            {badge > 0 && <motion.span initial={{ scale: 0 }} animate={{ scale: 1 }} data-testid={`tabbar-${label.toLowerCase()}-badge`} className="absolute -top-1.5 -right-2.5 min-w-[16px] h-4 px-1 rounded-full bg-rose-500 text-white text-[9px] leading-4 text-center">{badge > 9 ? "9+" : badge}</motion.span>}
          </span>
          <span className={`relative transition-colors ${isActive ? "text-[var(--ink)]" : "text-[var(--muted)]"}`}>{label}</span>
        </>
      )}
    </NavLink>
  );
}

export default function MobileTabBar() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const unread = useUnread(user);
  if (HIDE_TABBAR.test(pathname)) return null;
  return (
    <>
      <div className="lg:hidden h-[76px]" aria-hidden />
      <nav data-testid="mobile-tabbar"
        className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-[var(--line)] bg-[#FAF7F2]/85 backdrop-blur-xl flex items-stretch px-1 pt-1"
        style={{ paddingBottom: "max(0.4rem, env(safe-area-inset-bottom))" }}>
        <Tab to="/" label="Home" icon={Home} end />
        <Tab to="/explore" label="Explore" icon={Compass} />
        <Tab to="/community" label="Community" icon={Users} />
        <Tab to="/messages" label="Messages" icon={MessageCircle} badge={unread} />
        <Tab to={user ? "/dashboard" : "/login"} label="Me" icon={User} />
      </nav>
    </>
  );
}
